var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('AppHeader'),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.sidebarApps}}),_c('main',{staticClass:"main"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)]),_c('AppAside')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }